import React from "react";
import { Search, Eye, Signature, Key, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Search",
  description: "Browse our curated collection of premium properties, filtering by location, price, and amenities to find your perfect match.",
  icon: Search
}, {
  title: "View",
  description: "Schedule a private or virtual viewing to experience the property firsthand and ensure it meets your lifestyle needs.",
  icon: Eye
}, {
  title: "Offer",
  description: "Submit your application through our streamlined digital platform. We guide you through referencing and securing the tenancy.",
  icon: Signature
}, {
  title: "Move-in",
  description: "Collect your keys, complete the digital inventory, and settle into your new home with our comprehensive welcome support.",
  icon: Key
}];
export default function RentersRoadmap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="renters-roadmap" ref={ref} className="bg-background relative overflow-hidden py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className={cn("mb-16 text-center transition-all duration-1000 ease-out md:mb-24", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-foreground font-serif text-4xl font-medium tracking-tight sm:text-5xl">
            Renter’s Roadmap
          </h2>
          <p className="text-muted-foreground font-sans mx-auto mt-4 max-w-2xl text-lg">
            Your journey to a new home, simplified. Follow our step-by-step guide to renting with confidence.
          </p>
        </div>

        {}
        <div className="relative mx-auto max-w-5xl">
          {}
          <div className="absolute left-8 top-0 h-full w-0.5 -translate-x-1/2 bg-border md:left-1/2">
            <div className={cn("bg-secondary absolute top-0 left-0 w-full transition-all duration-[2000ms] ease-in-out", isVisible ? "h-full" : "h-0")} />
          </div>

          <div className="space-y-12 md:space-y-24">
            {steps.map((step, index) => {
            const Icon = step.icon;
            const isEven = index % 2 === 0;
            return <div key={index} data-index={index} className={cn("relative flex flex-col md:flex-row md:items-center", isEven ? "md:flex-row-reverse" : "")}>
                  {}
                  <div className="absolute left-8 top-0 flex -translate-x-1/2 items-center justify-center md:static md:left-1/2 md:w-0 md:translate-x-0">
                    <div className={cn("bg-background border-secondary text-secondary z-10 flex size-16 shrink-0 -translate-x-1/2 items-center justify-center rounded-full border-2 shadow-lg transition-all duration-700 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-50")} style={{
                  transitionDelay: `${index * 200}ms`
                }}>
                      <Icon className="size-7" />
                    </div>
                  </div>

                  {}
                  <div className="hidden md:block md:w-1/2" />

                  {}
                  <div className="ml-20 md:ml-0 md:w-1/2 md:px-12">
                    <div className={cn("transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-x-0" : isEven ? "opacity-0 -translate-x-10" : "opacity-0 translate-x-10")} style={{
                  transitionDelay: `${index * 200 + 200}ms`
                }}>
                      <h3 className={cn("text-foreground font-serif mb-3 text-2xl font-medium", !isEven ? "md:text-right" : "md:text-left")}>
                        {step.title}
                      </h3>
                      <p className={cn("text-muted-foreground font-sans text-lg leading-relaxed", !isEven ? "md:text-right" : "md:text-left")}>
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className={cn("mt-20 flex justify-center transition-all duration-1000 delay-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 h-14 px-8 text-base font-semibold uppercase tracking-wide shadow-md">
            <Link to="/PropertiesPage">
              Start Your Search <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}